import React from 'react'
import styled from '@emotion/styled'
import Typography from '@mui/material/Typography'

const MXCancellationPolicyContainer = styled('div')(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    paddingBottom: '0.5rem',
    borderBottom: `1px solid ${theme.palette.secondary.main}`,
    [theme.breakpoints.down('sm')]: {
      margin: '0 1rem',
    },
  }))

export const MXCancellationPolicy = () => {
  return (
    <MXCancellationPolicyContainer>
      <Typography sx={{fontSize: '24px', fontWeight: 'bold'}} color="white">
        Cancellation Policy
      </Typography>
      
      <ul>
        <li>Mexican airspace fee submissions cannot be refunded</li>
        <li>Payments made to the Mexican government as a result of customer data entry errors for tail number, operator/owner name, departure airport, arrival airport, or flight date CANNOT be refunded, nor can they be corrected. The Mexican government does not allow fees paid for one user to be applied to another user nor do they allow fees paid for one date to be applied to a different date, nor do they give refunds. A completely new payment to correct the error must be paid and the erroneous payment is forfeited</li>
        <li>CST Members who fail to validate their CST Member email during this submission process will be charged full rate and no partial refunds can be given</li>
        
      </ul>
    </MXCancellationPolicyContainer>
  )
}
